import CustomerInvoiceTemplate from "./TaghezPrint";

// ✅ عدّل التوقيع: استقبل كائن واحد يحتوي على { order, items }
export const handleBrowserPrint = async (printData) => {
  
  const { order, items } = printData || {};

  if (!order) {
    alert("❌ بيانات الأوردر مفقودة.");
    return;
  }

  const printWindow = window.open("", "printWindow", "width=400,height=600");
  if (printWindow) {
    // ✅ مرّر items إلى CustomerInvoiceTemplate (order يحتوي على open_time)
    const html = await CustomerInvoiceTemplate(order, order?.invoiceSettings || {}, order?.id, items);
    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
  
    // تأكد أن نافذة الطباعة تُغلق بعد انتهاء الطباعة (مع احتياطي)
    const tryClose = () => {
      try {
        if (printWindow && !printWindow.closed) printWindow.close();
      } catch (e) {
        // ignore
      }
    };
    

    // attach both handlers for broader browser support
    printWindow.onafterprint = tryClose;
    try {
      printWindow.addEventListener && printWindow.addEventListener("afterprint", tryClose);
    } catch (e) {
      /* ignore */
    }

    // احتياطي: أغلق النافذة بعد 12 ثانية إذا لم يتم إغلاقها بواسطة الحدث
    const fallbackTimer = setTimeout(() => {
      tryClose();
    }, 12000);

    // تأكد إزالة الـ timeout لو تم الإغلاق بالفعل
    const clearIfClosed = () => {
      if (!printWindow || printWindow.closed) {
        clearTimeout(fallbackTimer);
        try {
          printWindow.onafterprint = null;
          printWindow.removeEventListener && printWindow.removeEventListener("afterprint", tryClose);
        } catch (e) {}
      }
    };

    // استدعاء الطباعة ثم تحقق دوري إن أُغلقت النافذة
    printWindow.print();
    const pollInterval = setInterval(() => {
      if (!printWindow || printWindow.closed) {
        clearInterval(pollInterval);
        clearIfClosed();
      }
    }, 500);
  } else {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
  }
};
